export const FORGOTTEN_PASSWORD = "password/sagas/FORGOTTEN_PASSWORD";
export const RESET_PASSWORD = "password/sagas/RESET_PASSWORD";
